<div class="box-transparent" *ngIf="reinsured" [routerLink]="['/']"></div>
<div [ngClass]="['container',getEntityClass(),'sbs', reinsured ? 'reinsured':'no-reinsured', takerBlocked ? 'back-full':'']" [style.--entity]="reinsured">

    <section class="side-right" [ngClass]="{'brand-panel': !reinsured}" *ngIf="!takerBlocked">
        <div class="brand-content" *ngIf="!reinsured" [@fadeIn]>
            <h1 class="brand-title">Tu equipo legal, siempre contigo</h1>
            <p class="panel-subheadline">Accede y disfruta de todas las ventajas de ser cliente de onLygal</p>
        </div>
        <app-picture-with-text *ngIf="reinsured" [isReinsured]="reinsured"></app-picture-with-text>
    </section>

    <section class="side-left" *ngIf="!takerBlocked">
        <img *ngIf="!reinsured" class="brand-logo" src="/resources/assets/images/login/logo-login.png" alt="onLygal – Actuamos soluciones legales para vidas reales" [routerLink]="['/']" />
        <app-register-form (onRegisterSubmit)="onRegisterSubmit($event)" (onTakerBlock)="onTakerBlock($event)" [isInnominado]="innominado" [isReinsured]="reinsured" [formGroup]="registerForm">
        </app-register-form>
    </section>

    <div class="center" *ngIf="takerBlocked">
        <app-taker-block-notify></app-taker-block-notify>
    </div>

</div>
